import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AddBannerForm from './AddBannerSettings';

const AddBannerPage = ({ onCancel }: { onCancel: () => void }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <AddBannerForm onCancel={onCancel} />
    </LocalizationProvider>
  );
};

export default AddBannerPage;
